<template>
<div id="chart">
  <apexchart v-if="!load && !isList" type="line" height="350" :options="chartOptions" :series="series"></apexchart>
  <v-skeleton-loader
        v-if="load"
        ref="skeleton"
        type="card">
  </v-skeleton-loader>
</div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import faturamentoService from './../../services/faturamentoService'
import { EventBus } from './../../main'

export default {
  name: 'faturamentoMensal',
  props: {
    idEmpresa: Number,
    idUnidade: Number,
    idExameEspecialidade: Number,
    idMedicoSolicitante: Number,
    dataInicio: String,
    dataFim: String,
    valorMinimo: Number,
    valorMeta: Number,
    valorMetaAnual: Number,
    valorMinimoAnual: Number,
    idConvenio: Number,
    idExame: Number
  },
  components: {
    apexchart: VueApexCharts
  },
  data () {
    return {
      load: false,
      series: [],
      isList: false,
      chartOptions: {
        colors: ['#008FFB', '#B0BEC5'],
        chart: {
          height: 350,
          type: 'line',
          zoom: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          width: [5, 7, 5],
          curve: 'straight',
          dashArray: [0, 8, 5]
        },
        title: {
          text: 'Estatísticas',
          align: 'left'
        },
        legend: {
          tooltipHoverFormatter: function (val, opts) {
            return val + ' - ' + opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] + ''
          }
        },
        markers: {
          size: 0,
          hover: {
            sizeOffset: 6
          }
        },
        annotations: {
          yaxis: [],
          xaxis: [
            // {
            // // in a datetime series, the x value should be a timestamp, just like it is generated below
            //   x: 10,
            //   x2: 11,
            //   strokeDashArray: 0,
            //   fillColor: '#F8BBD0',
            //   label: {
            //     borderColor: '#E91E63',
            //     style: {
            //       color: '#fff',
            //       background: '#E91E63'
            //     },
            //     text: 'Outubro rosa'
            //   }
            // },
            // {
            // // in a datetime series, the x value should be a timestamp, just like it is generated below
            //   x: 11,
            //   x2: 12,
            //   strokeDashArray: 0,
            //   fillColor: '#BBDEFB',
            //   label: {
            //     borderColor: '#2196F3',
            //     style: {
            //       color: '#fff',
            //       background: '#2196F3'
            //     },
            //     text: 'Novembro azul'
            //   }
            // }
          ]
        },
        xaxis: {
          categories: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']
        },
        tooltip: {
          y: [
            {
              title: {
                formatter: function (val) {
                  return val
                }
              }
            },
            {
              title: {
                formatter: function (val) {
                  return val
                }
              }
            }
          ]
        },
        grid: {
          borderColor: '#f1f1f1'
        }
      }
    }
  },
  methods: {
    carregarDados () {
      // var dateInicio = this.dataInicio.split('-')
      var dateFinal = this.dataFim.split('-')
      this.load = true
      EventBus.$emit('loadStop', 1)
      faturamentoService.rankingGeral({
        idEmpresa: this.idEmpresa,
        idUnidadeNegocio: this.idUnidade,
        idExameEspecialidade: this.idExameEspecialidade,
        idMedicoSolicitante: this.idMedicoSolicitante,
        dataInicio: this.dataInicio,
        dataFim: this.dataFim,
        idConvenio: this.idConvenio,
        idExame: this.idExame
      }).then(r => {
        if (r.status === 200) {
          let lista = []
          let listaAnoAnteiro = []
          let faturaMes = 0
          let anoAtual = ''
          let anoAnterior = ''
          let valorTotal = 0
          let qtdOS = 0
          let qtdOSMes = 0
          let mesAnterior = 0
          this.isList = false
          // console.log(r.data)
          if (r.data.anos1.length > 0 && r.data.anos2.length > 0) {
            for (let i = 1; i < 13; i++) {
              const e = r.data.anos2[i]
              if (e != null) {
                // lista.push(e.valorFaturado)
                anoAtual = e.ano
                valorTotal += e.valorFaturado
                qtdOS += e.qtdOS
                if (e.mes === parseInt(dateFinal[1])) {
                  faturaMes = e.valorFaturado
                  qtdOSMes = e.qtdOS
                  lista.splice(e.mes, 0, null)
                } else {
                  lista.splice(e.mes, 0, parseInt(e.valorFaturado))
                }
              } else {
                lista.push(null)
              }
            }
            for (let i = 1; i < 13; i++) {
              const e = r.data.anos1[i]
              if (e != null) {
                // lista.push(e.valorFaturado)
                anoAnterior = e.ano
                if (e.mes === parseInt(dateFinal[1])) {
                  mesAnterior = parseInt(r.data.mesAnoAnterior)
                }
                listaAnoAnteiro.splice(e.mes, 0, parseInt(e.valorFaturado))
              } else {
                listaAnoAnteiro.push(null)
              }
            }

            var f = {
              ticketMedio: (valorTotal / qtdOS),
              ticketMedioMes: (faturaMes / qtdOSMes),
              valorTotal: valorTotal,
              qtdOS: qtdOS,
              qtdOSMes: qtdOSMes,
              faturaMes: faturaMes,
              faturaMesAnterior: mesAnterior
            }
            this.$emit('faturamento', f)
            this.series = [{
              name: `Produção (${anoAtual})`,
              data: lista
            },
            {
              name: `Produção (${anoAnterior})`,
              data: listaAnoAnteiro
            }]
            let marcadoresY = [
              {
                y: this.valorMinimo + (this.valorMinimo * 0.8),
                y2: this.valorMinimo + (this.valorMinimo * 0.6),
                fillColor: '#9CCC65',
                label: {
                  borderColor: '#9CCC65',
                  style: {
                    color: '#000',
                    background: '#9CCC65'
                  },
                  text: '.'
                }
              },
              // {
              //   y: this.valorMinimo + (this.valorMinimo * 0.6),
              //   y2: this.valorMinimo + (this.valorMinimo * 0.4),
              //   fillColor: '#FFF176',
              //   borderColor: '#FFF176',
              //   label: {
              //     borderColor: '#FFF176',
              //     style: {
              //       color: '#000',
              //       background: '#FFF176'
              //     },
              //     text: '.'
              //   }
              // },
              {
                y: this.valorMinimo + (this.valorMinimo * 0.4),
                y2: this.valorMinimo + (this.valorMinimo * 0.2),
                fillColor: '#FF7043',
                label: {
                  borderColor: '#FF7043',
                  style: {
                    color: '#000',
                    background: '#FF7043'
                  },
                  text: '.'
                }
              },
              {
                y: this.valorMinimo,
                borderColor: '#E57373',
                label: {
                  borderColor: '#E57373',
                  style: {
                    color: '#fff',
                    background: '#E57373'
                  },
                  text: 'Mínimo'
                }
              }]
            this.chartOptions.annotations.yaxis = marcadoresY
          // this.series[1].data = lista
          // this.series[2].data = listaAnoAnteiro
          } else {
            this.isList = true
          }
        }
      }).finally(() => {
        EventBus.$emit('loadStop', -1)
        this.load = false
      })
    },
    formatValue (value) {
      const val = Number(value.toString().replace(',', '.'))
      if (!val) return '0,00'
      const valueString = val.toFixed(2).replace('.', ',')
      return valueString.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    }
  },
  watch: {
    idEmpresa: function (val) { this.carregarDados() },
    idUnidade: function (val) { this.carregarDados() },
    idExameEspecialidade: function (val) { this.carregarDados() },
    idMedicoSolicitante: function (val) { this.carregarDados() },
    dataInicio: function (val) { this.carregarDados() },
    dataFim: function (val) { this.carregarDados() }
  },
  mounted () {
    this.carregarDados()
  }
}
</script>
